/**
 * Vista: Lista de Entregas de Tractor
 * Formato: AMX-VTA-FR-07
 */

import ventasService from '../services/ventas.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Entregas de Tractor</h2>
          ${permisos.canCreate('entregas') ? `
            <button class="btn btn-primary" onclick="router.navigate('/ventas/entregas/nueva')">
              + Nueva Entrega
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas rápidas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Entregas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCompletadas" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Completadas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPendientes" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Pendientes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statMes" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Este Mes</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Usuario..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="completadaFilter" class="form-input">
              <option value="">Todos</option>
              <option value="true">Completadas</option>
              <option value="false">Pendientes</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.entregasListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Usuario/Cliente</th>
                <th class="tbl-hide-mobile">Horas Motor</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="entregasTableBody">
              <tr>
                <td colspan="8" style="text-align: center; padding: 2rem;">
                  Cargando entregas...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('entregas')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.entregasListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarEntregas();
      }, 500);
    });

    document.getElementById('completadaFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.completada;
      } else {
        this.filters.completada = e.target.value === 'true';
      }
      this.currentPage = 1;
      this.cargarEntregas();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarEntregas();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarEntregas();
    });

    await this.cargarEstadisticas();
    await this.cargarEntregas();
  },

  async cargarEstadisticas() {
    try {
      const response = await ventasService.obtenerEstadisticasEntregas();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statCompletadas').textContent = stats.completadas || 0;
      document.getElementById('statPendientes').textContent = stats.pendientes || 0;
      document.getElementById('statMes').textContent = stats.este_mes || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarEntregas() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await ventasService.listarEntregas(params);
      // La respuesta viene como { data: { entregas: [], pagination: {} } }
      const data = response.data || response;
      const entregas = data.entregas || [];
      const pagination = data.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderEntregas(Array.isArray(entregas) ? entregas : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar entregas');
      console.error('Error:', error);
      this.renderEntregas([]);
    }
  },

  renderEntregas(entregas) {
    const tbody = document.getElementById('entregasTableBody');

    if (!entregas || entregas.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="8" style="text-align: center; padding: 2rem;">
            No se encontraron entregas
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = entregas.map(e => {
      const fechaStr = new Date(e.fecha).toLocaleDateString('es-MX');
      const estadoBadge = `<span class="badge ${e.completada ? 'badge-success' : 'badge-warning'}">${e.completada ? 'Completada' : 'Pendiente'}</span>`;
      const accionesHtml = `
        ${e.completada
          ? (permisos.canView('entregas') ? `<button class="btn btn-sm btn-primary" onclick="window.entregasListView.verDetalle(${e.id})">Ver</button>` : '')
          : `${permisos.canEdit('entregas') ? `<button class="btn btn-sm btn-primary" onclick="window.entregasListView.verDetalle(${e.id})">Editar</button>` : ''}
             ${permisos.canDelete('entregas') ? `<button class="btn btn-sm btn-danger" onclick="window.entregasListView.eliminarEntrega(${e.id}, '${e.num_serie}')">Eliminar</button>` : ''}`
        }
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.entregasListView.toggleRow(${e.id})">&#9654;</button></td>
        <td><strong>${e.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaStr}</td>
        <td class="tbl-hide-mobile">${e.modelo || '-'}</td>
        <td class="tbl-hide-mobile">${e.usuario}</td>
        <td class="tbl-hide-mobile">${e.horas_motor} hrs</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-ent-${e.id}">
        <td colspan="8" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaStr}</dd>
            <dt>Modelo</dt><dd>${e.modelo || '-'}</dd>
            <dt>Usuario</dt><dd>${e.usuario}</dd>
            <dt>Horas Motor</dt><dd>${e.horas_motor} hrs</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.entregasListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.entregasListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.entregasListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-ent-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarEntregas();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('completadaFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarEntregas();
  },

  verDetalle(id) {
    router.navigate(`/ventas/entregas/${id}`);
  },

  eliminarEntrega(id, numSerie) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar la entrega del tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await ventasService.eliminarEntrega(id);
          toast.success('Entrega eliminada');
          await this.cargarEstadisticas();
          await this.cargarEntregas();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
          console.error(error);
        }
      }
    );
  }
};
